import { LoadSpinner } from '@calizahq/react-components-v2'
import React, { useMemo } from 'react'

import { NoResults, Table } from '@/components'
import ListFilter, { FilterTypes } from '@/components/ListFilter/ListFilter'
import { useMobile } from '@/hooks'
import useMembers from '@/hooks/useMembers/useMembers'
import { MemberListRow } from '@/types/User'

import { MembersListColumns, membersListMapping } from './Members.data'
import { MobileMemberCard } from './MobileMemberCard'

export function Members() {
  const membersQuery = useMembers()

  const data: MemberListRow[] = useMemo(() => {
    return membersQuery?.data && membersQuery?.data.members ? membersListMapping(membersQuery?.data.members) : []
  }, [membersQuery?.data])

  const columns = useMemo(() => {
    return MembersListColumns
  }, [])

  const { isMobile } = useMobile()

  return (
    <div className="flex w-full flex-col p-4 md:p-8">
      <ListFilter
        hideFilters={true}
        hideLengthOfStayFilter={true}
        hideMarketSegment={true}
        hideReservationMoveInFilter={true}
        hideReservationMoveOutFilter={true}
        hideSearch={false}
        listType={FilterTypes.MEMBER}
        title="Members"
      />
      {membersQuery?.isLoading ? (
        <div className="flex h-20 w-full items-center justify-center">
          <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
        </div>
      ) : (
        <>
          {isMobile ? (
            <>
              {data && data.map((member, index) => <MobileMemberCard key={index} member={member} />)}
              {data.length === 0 && <NoResults />}
            </>
          ) : (
            <Table className={''} columns={columns as any} data={data} />
          )}
        </>
      )}
    </div>
  )
}
